import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './AdditionalInfoForm.jsx'

export default createSubmit(name)